import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MessageModal = ({ isOpen, onClose, influencerName }) => {
  const [message, setMessage] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState('');

  const messageTemplates = [
    {
      id: 'intro',
      title: 'Tanışma Mesajı',
      content: `Merhaba ${influencerName},\n\nProfilinizi inceledim ve işbirliği yapmak isterim. Müzik projelerim hakkında konuşabilir miyiz?`
    },
    {
      id: 'campaign',
      title: 'Kampanya Teklifi',
      content: `Merhaba ${influencerName},\n\nYaklaşan single lansmanım için sizinle çalışmak istiyorum. Detayları görüşebilir miyiz?`
    },
    {
      id: 'pricing',
      title: 'Fiyat Sorgusu',
      content: `Merhaba ${influencerName},\n\nHizmet paketleriniz hakkında daha fazla bilgi alabilir miyim? Özel bir teklif için görüşmek isterim.`
    }
  ];

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template?.id);
    setMessage(template?.content);
  };

  const handleSend = () => {
    if (message?.trim()) {
      console.log('Mesaj gönderiliyor:', message);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 z-[2000] flex items-center justify-center p-4">
      <div className="bg-card rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-6 z-10">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-semibold text-foreground">Mesaj Gönder</h2>
              <p className="text-sm text-muted-foreground mt-1">{influencerName}</p>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-muted rounded-lg transition-smooth"
            >
              <Icon name="X" size={20} />
            </button>
          </div>
        </div>

        <div className="p-6 space-y-6">
          <div>
            <label className="block text-sm font-medium text-foreground mb-3">
              Hızlı Şablonlar
            </label>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              {messageTemplates?.map((template) => (
                <button
                  key={template?.id}
                  onClick={() => handleTemplateSelect(template)}
                  className={`
                    p-4 rounded-lg border-2 text-left transition-smooth
                    ${selectedTemplate === template?.id
                      ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50'
                    }
                  `}
                >
                  <p className="text-sm font-medium text-foreground">{template?.title}</p>
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Mesajınız
            </label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e?.target?.value)}
              placeholder="Mesajınızı buraya yazın..."
              rows={8}
              className="w-full px-3 py-2 bg-background border border-input rounded-md text-foreground focus:outline-none focus:ring-2 focus:ring-ring resize-none"
            />
            <p className="text-xs text-muted-foreground mt-2">
              {message?.length} / 1000 karakter
            </p>
          </div>

          <div className="p-4 bg-muted rounded-lg">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">İletişim İpuçları</p>
                <ul className="text-sm text-muted-foreground space-y-1">
                  <li>• Kendinizi ve projenizi kısaca tanıtın</li>
                  <li>• Beklentilerinizi net bir şekilde belirtin</li>
                  <li>• Profesyonel ve saygılı bir dil kullanın</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="flex gap-3 pt-4 border-t border-border">
            <Button
              type="button"
              variant="outline"
              fullWidth
              onClick={onClose}
            >
              İptal
            </Button>
            <Button
              type="button"
              variant="default"
              fullWidth
              iconName="Send"
              iconPosition="left"
              onClick={handleSend}
              disabled={!message?.trim()}
            >
              Mesaj Gönder
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageModal;